import { ClassValue } from 'classnames/types'

import { TColProps } from './Col'

const columns = [3, 4, 6, 8, 12]
const widths = {
  default: ['w-1/4', 'w-1/3', 'w-1/2', 'w-2/3', 'w-full'],
  sm: ['sm:w-1/4', 'sm:w-1/3', 'sm:w-1/2', 'sm:w-2/3', 'sm:w-full'],
  md: ['md:w-1/4', 'md:w-1/3', 'md:w-1/2', 'md:w-2/3', 'md:w-full'],
  lg: ['lg:w-1/4', 'lg:w-1/3', 'lg:w-1/2', 'lg:w-2/3', 'lg:w-full'],
}

const getWidthClasses = (props: TColProps): ClassValue => {
  const widthClasses = [
    getWidthForBreakpoint(props.width, widths.default),
    getWidthForBreakpoint(props.sm, widths.sm),
    getWidthForBreakpoint(props.md, widths.md),
    getWidthForBreakpoint(props.lg, widths.lg),
  ].filter(Boolean)
  return widthClasses.length > 0 ? ['flex-none', ...widthClasses] : undefined
}

const getWidthForBreakpoint = (count: number | undefined, collection: string[]): string | undefined => {
  return typeof count !== 'undefined' ? collection[columns.indexOf(count)] : undefined
}

export default getWidthClasses
